module.exports = __webpack_public_path__ + "media/images/trash-93d53c3ef4b1de027155df0ebb734a46.svg";